module.exports = __webpack_public_path__ + "static/video-1-1-2b381e53e9e5d69f929a46aaf84bbe4a.jpg";